import { Injectable, Injector } from '@angular/core';
import { HttpClient } from '@angular/common/http';

import { Voorblad } from '../dto/voorblad';
import { CrudService, Filter } from '@mango/core';
import { map } from 'rxjs/operators';

@Injectable({ providedIn: 'root' })
export class VoorbladService extends CrudService<Voorblad> {

    constructor(injector: Injector) { super(Voorblad, injector); }

    kopieerVoorblad(voorblad: Voorblad) {
        let query: string = `api/dto/voorblad/kopieer?voorbladId=${voorblad.id}`;

        return this.http.post(query, null).pipe(map(x => x as VoorbladResponse));

    } 

    getIdFilter(Id: number): Filter<Voorblad> {
        return new Filter<Voorblad>(fb => [fb.equal("id", Id)]);        
    }

    getActiefFilter(): Filter<Voorblad> {
        return new Filter<Voorblad>(fb => [fb.equal("actief",true)]);
    }

    openDirectory(dir: string) {

        let query: string = `http://localhost:3000/?location=${dir}`;

        window.open(query,"_blank");

    }
}

export class VoorbladResponse {
    successful: boolean;
    voorbladId: number;
    message: string;
}